import { render, staticRenderFns } from "./Section-08.vue?vue&type=template&id=4dcbcb52&scoped=true&"
import script from "./Section-08.vue?vue&type=script&lang=js&"
export * from "./Section-08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbcb52",
  null
  
)

export default component.exports